import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles.styl';

export const SSNField = ({
  children,
  className,
  extraClass,
  formatMessage,
  noMarginBottom,
}) => {
  return (
    <Fragment>
      {children}
      <div
        className={cn(
          className,
          styles.ssnDescription,
          {
            [styles.noMarginBottom]: noMarginBottom,
          },
          extraClass,
        )}
      >
        {formatMessage({ id: 'profile.fields.ssnDescription' })}
      </div>
    </Fragment>
  );
};

SSNField.propTypes = {
  className: PropTypes.string,
  extraClass: PropTypes.string,
  formatMessage: PropTypes.func,
  noMarginBottom: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
};



// WEBPACK FOOTER //
// ./src/components/SSNField/index.jsx